import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './creditCardIcon.sass'

const CreditCardIcon = props => (
  <div
    className={classNames(
      props.className,
      'credit-card-icon',
      `--type-${props.cardType.toLowerCase().replace(/[ -]/, '')}`,
      { '--big': props.big }
    )}
  />
)

CreditCardIcon.propTypes = {
  className: PropTypes.string,
  cardType: PropTypes.string.isRequired,
  big: PropTypes.bool,
}

CreditCardIcon.defaultProps = {
  className: '',
  big: '',
}

export default CreditCardIcon
